import { Expose, Type } from 'class-transformer';

class AccountableModel {
  id: string;
  name: string;
}

export class TippingModel {
  id: string;
  number: string;
  status: string;
  description: string;

  @Expose({ name: 'account_type' })
  accountType: string;

  @Type(() => AccountableModel)
  accountable: AccountableModel;

  @Type(() => Number)
  amount: number;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;
}

export class getTourTippingsInput {
  id: string;
  params: {
    page: number;
    filter?: string;
    limit?: number;
    q?: string;
  };
}

export class TipMutationInput {
  transactionAt?: Date | null;
  amount: number;
  description: string;
  accountType: string;
  accountableId?: string;
}

export class TipCreateInput {
  tourId: string;
  body: { tips: TipMutationInput[] };
}

export class TipUpdateInput {
  tipId: string;
  body: TipMutationInput;
}

export class TipDeleteInput {
  tipId: string;
}
